module.exports = __webpack_public_path__ + "img/_Middle-Semi-Elliptical-Attachment-L.cdb1ed26.jpg";